import axios from "../../../../api/axios";

import { ReviewsResponse, ReviewType, ReviewTypeEnum } from "../types/reviews.types";

const REVIEWS_PAGE_LIMIT = 10;

export const getUserReviews = async (
  userId: string,
  limit: number = REVIEWS_PAGE_LIMIT,
  offset: number = 0,
  type: ReviewType = ReviewTypeEnum.RECEIVED
): Promise<ReviewsResponse> => {
  try {
    const response = await axios.get<ReviewsResponse>(
      `users/${userId}/reviews?offset=${offset}&limit=${limit}&type=${type}`
    );
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch user reviews: ${(err as Error).message}`);
  }
};
